import { User } from "oidc-client-ts";
import { useAuth } from "react-oidc-context";
import { Navigate } from "react-router-dom";
import Typography from "@mui/material/Typography";
import { EmptyContent } from "@imminently/react/ui/core/empty-content";
import { useConfigContext } from "@imminently/react/context/config";

const userHasGroup = (user: User | null | undefined, groups: string) => {
  if (!groups) return true; // In the case of no configured groups let them through
  if (!user) return false; // If no user - force unauthorised
  const appGroups = groups.split(",").map((g) => g.trim());
  const userGroups = (user?.profile?.groups ?? []) as string[];
  return userGroups.some((g) => appGroups.includes(g));
};

export const Auth = () => {
  const params = new URLSearchParams(window.location.search);
  const config = useConfigContext();
  const { activeNavigator, isLoading, isAuthenticated, user, removeUser } = useAuth();

  const noAuth = config.auth.type === "none";

  if (noAuth || (isAuthenticated && !isLoading)) {
    // need to check the user has a valid group
    if (!userHasGroup(user, config.auth.groups)) {
      // delete the token, prefer delete as logout redirects and fully signs them out of azure
      removeUser();
      return <Navigate to='/unauthorized' replace />;
    }
    // successfully signed in, redirect
    return <Navigate to='/patients' replace />;
  }

  if (params.get("error")) {
    // error signing in, display error
    return (
      <EmptyContent>
        <Typography variant="h3">
          {params.get("error")}
        </Typography>
        <Typography variant="h4" mt={4} maxWidth={400}>
          {params.get("error_description")}
        </Typography>
      </EmptyContent>
    );
  }

  if (!activeNavigator) return null;

  const isSignout = activeNavigator?.startsWith("signout");

  return (
    <EmptyContent image="/favicon.svg" width="10rem">
      <Typography variant="h4" mt={4}>
        {isSignout ? "Signing you out..." : "Signing you in..."}
      </Typography>
    </EmptyContent>
  );
};